import { getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import { Button } from "@faire/web--source/slate/Button";
import { trackHelpCenterOpenQuickModalEventClick } from "@faire/web-api--source/events/helpCenter/click/openQuickModalEvent";
import { trackHelpCenterShortcutsClick } from "@faire/web-api--source/events/helpCenter/click/shortcuts";
import * as React from "react";

import { QuickActionOrigin } from "./QuickActions";
import { QuickAction } from "./types";

interface QuickActionButtonProps {
  origin: QuickActionOrigin;
  actionType: QuickAction;
  setActionType: (actionType: QuickAction) => void;
}

export const QuickActionButton: React.FC<QuickActionButtonProps> = ({
  actionType,
  setActionType,
  origin,
}) => {
  const retailerToken = getRetailerToken() ?? "";
  const brandToken = getBrandToken() ?? "";

  const trackOpenModalEvent = () => {
    trackHelpCenterOpenQuickModalEventClick(actionType.label);
    trackHelpCenterShortcutsClick(
      retailerToken,
      brandToken,
      origin,
      actionType.id
    );
    setActionType(actionType);
  };

  return (
    <Button
      style={{ textAlign: "left" }}
      variant="tertiary"
      onClick={trackOpenModalEvent}
    >
      {actionType.label}
    </Button>
  );
};
